import {Card} from 'platform/components';

import {RequiredTestIdProps, suffixTestId} from 'shared/web';

import {CheckoutPaymentCardV2} from './CheckoutPaymentCardV2';

interface CorrectiveTaxDocumentCardV2Props extends RequiredTestIdProps {
  paymentId: string;
  checkoutId: string;
  customerId: string;
  serviceCaseId?: string;
  serviceOrderId?: string;
  isEditingDisabled?: boolean;
  isCompletingDisabled?: boolean;
}

export function CorrectiveTaxDocumentCardV2(props: CorrectiveTaxDocumentCardV2Props) {
  return (
    <Card variant="inlineGrey">
      <CheckoutPaymentCardV2
        paymentId={props.paymentId}
        checkoutId={props.checkoutId}
        customerId={props.customerId}
        serviceCaseId={props.serviceCaseId}
        serviceOrderId={props.serviceOrderId}
        isEditingDisabled={props.isEditingDisabled}
        isCompletingDisabled={props.isCompletingDisabled}
        data-testid={suffixTestId('card', props)}
      />
    </Card>
  );
}
